import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import styled from 'styled-components';

import { useTranslation } from '../../i18n';

import { Card } from '../element';
import { FeedBackForm } from './feedback-form';
import { sendFeedBackAct } from '../../entities/feedback/actions';

const Title = styled.legend`
  font-size: 21px;
  padding: 0 0 9px;
`;

const Caption = styled.legend`
  font-size: 12px;
  padding: 0 0 9px;
`;

export const FeedBack: React.FC = () => {
  const [t] = useTranslation('contacts');
  const dispatch = useDispatch();

  const handleSubmit = useCallback((message) => {
    dispatch(sendFeedBackAct({ message }));
  }, []);

  return (
    <Card className="mb-20 is-hover-shadow">
      <Title>{t('contacts.form.title')}</Title>
      <Caption>{t('contacts.form.help')}</Caption>

      <FeedBackForm handleSubmit={handleSubmit} />
    </Card>
  );
};
